module.exports = __webpack_public_path__ + "img/collage_img_04.41fb7ebb.jpg";